import * as React from 'react';
import * as Styled from './topBannerStyles';
import { graphql, useStaticQuery } from 'gatsby';
import constants from '../../utils/utils';

const TopBanner = ({ path }) => {
  const result = path?.split('/').filter((n) => n);
  const commonBanner = useStaticQuery(graphql`
    query commonBannerQuery {
      allContentfulChevron(
        filter: { identifier: { type: { eq: "commonBanner" } } }
      ) {
        edges {
          node {
            id
            name
            title
            sections {
              ... on ContentfulListOfImageWithPath {
                id
                type
                title
                listOfImagesWithPath {
                  image {
                    file {
                      fileName
                      url
                    }
                  }
                  title
                  type
                  richText {
                    raw
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const commonBannerSections =
    commonBanner.allContentfulChevron.edges[0].node.sections;
  const commonBannerData = commonBannerSections?.filter(
    (section) => section.type === result[0]
  )[0];
  const commonBannerDataDesktop = commonBannerData?.listOfImagesWithPath.filter(
    (section) => section.type === constants.COMMON.COMMOM_BANNER_DESKTOP
  )[0];
  const commonBannerDataTablet = commonBannerData?.listOfImagesWithPath?.filter(
    (section) => section.type === constants.COMMON.COMMOM_BANNER_MOBILE
  )[0];

  return (
    <>
      <Styled.BannerContainer
        $backgroundImageUrl={commonBannerDataDesktop?.image?.file?.url}
        $backgroundImageTabletUrl={
          commonBannerDataTablet?.image?.file?.url ??
          commonBannerDataTablet?.image?.file?.url
        }
        className="d-none d-md-block"
      >
        <Styled.BannerInnerContainer></Styled.BannerInnerContainer>
      </Styled.BannerContainer>
    </>
  );
};

export default TopBanner;
